<section class="users-view">

  <div class="row">
    <div class="col-12">
      <!-- Transaction detail starts -->
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <div class="col-12">
              <h5 class="mb-2 text-bold-500">
                <i class="ft-info mr-2"></i> Transaction Info
              </h5>
              <button class="btn mb-2 btn-primary float-right" (click)="openContent()">
                Pay Now
              </button>
              <div class="table-responsive">
                <h5>{{userData?.name | titlecase }}</h5>
                <table class="table mb-0">
                  <thead>
                    <tr>
                      <th>Net Fee</th>
                      <th>Total Paid</th>
                      <th>Paid Fee</th>
                      <th>Pending Fee</th>
                      <th>Mode</th>
                      <th>Transaction Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let transaction of transactionData">
                      
                      <td>
                        <span>{{ transaction.net_amount |  currency:'INR':'symbol' }}</span>
                      </td>
                      <td>
                        <span>{{ transaction.total_paid |  currency:'INR':'symbol' }}</span>
                      </td>
                      <td>
                        <span
                          class="badge bg-light-success">{{ transaction?.paid_amount |  currency:'INR':'symbol' }}</span>
                      </td>
                      <td>
                        <span
                          class="badge bg-light-danger">{{ transaction?.pendingAmount |  currency:'INR':'symbol' }}</span>
                      </td>
                      <td>
                        <span>{{ transaction?.mode?.displayname }}</span>
                      </td>
                      <td>
                        <span>{{ transaction?.created_at | date :'MMM d, y, h:mm a' }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Transaction detail ends -->
    </div>
  </div>
</section>